import { MatIconModule } from '@angular/material/icon'
import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { NzGridModule } from 'ng-zorro-antd/grid'
import { provideNgxMask } from 'ngx-mask'
import { NzLayoutModule } from 'ng-zorro-antd/layout'
import { NzCardModule } from 'ng-zorro-antd/card'
import { NzTableModule } from 'ng-zorro-antd/table'
import { NzDividerModule } from 'ng-zorro-antd/divider'
import { NzTagModule } from 'ng-zorro-antd/tag'
import { NzToolTipModule } from 'ng-zorro-antd/tooltip'
import { NzInputModule } from 'ng-zorro-antd/input'
import {
  ChecklistHeader,
  HeaderTypeEnum,
  StatusEnum
} from '@/app/modules/checklist-header/core/type'
import { Checklist, ChecklistImageModel } from '@/app/modules/checklist/core/type'
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal'
import { AvatarComponent } from '../../../../common/components/avatar/avatar.component'
import { NzSelectModule } from 'ng-zorro-antd/select'
import { UserService } from '@/app/modules/user/core/service'
import { LoaderService } from '@/app/common/services/loader/loader.service'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { User } from '@/app/modules/user/core/type'
import { ChecklistHeaderService } from '@/app/modules/checklist-header/core/service'
import { BehaviorSubject } from 'rxjs'
import { FormsModule } from '@angular/forms'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { NzEmptyModule } from 'ng-zorro-antd/empty'
import { HttpErrorResponse } from '@angular/common/http'
import { HasPermissionDirective } from '@/app/features/access/directives/has-permition.diirective'
import { ChecklistImageService } from '@/app/modules/checklist-image/core/service'

@Component({
  selector: 'az-item-component',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NzGridModule,
    NzLayoutModule,
    NzCardModule,
    NzTableModule,
    NzDividerModule,
    MatIconModule,
    NzTagModule,
    NzToolTipModule,
    NzInputModule,
    AvatarComponent,
    NzSelectModule,
    FormsModule,
    NzButtonModule,
    NzModalModule,
    NzEmptyModule,
    HasPermissionDirective,
  ],
  providers: [provideNgxMask(), NzModalService]
})
export class ItemComponent implements OnInit {
  @Input() checklistHeader?: ChecklistHeader
  @Input() checklistFound: Checklist[] = []
  isVisible: boolean[] = []

  @Output('edited') edited = new EventEmitter<boolean>()

  HeaderTypeEnum = HeaderTypeEnum

  users: User[] = []

  selectedUserTarget: number | null = null

  loader = new BehaviorSubject<boolean>(false)

  constructor (
    private loaderService: LoaderService,
    private userService: UserService,
    private notificationService: NzNotificationService,
    private checklistHeaderService: ChecklistHeaderService,
    private checklistImageService: ChecklistImageService,
    private modalService: NzModalService,
  ) {}

  ngOnInit (): void {
    this.loadUsers()
  }

  loadUsers () {
    return this.loaderService
      .executeWithLoader(
        this.userService.findAll({
          pageSize: 10000,
          pageIndex: 1
        }),
        this.loader
      )
      .subscribe({
        next: data => {
          this.users = data.items
        },
        error: error => {
          this.notificationService.error(
            'Erro ao buscar usuários',
            error.message
          )
        }
      })
  }

  getChecklistType (type?: HeaderTypeEnum): string {
    switch (type) {
      case 'used':
        return 'Usado'
      case 'transfer_start':
        return 'Transferência Enviada'
      case 'transfer_done':
        return 'Transferência Recebida'
      case 'new':
        return 'Novo'
      case 'vehicle':
        return 'Veículo'
      case 'maintenance':
        return 'Manutenção'
      case 'auction':
        return 'Leilão'
      default:
        return 'Transferência Enviada'
    }
  }

  createHeader () {
    if (this.checklistHeader && this.selectedUserTarget)
      this.loaderService
        .executeWithLoader(
          this.checklistHeaderService.create({
            type: HeaderTypeEnum.TRANSFER_DONE,
            product_id: this.checklistHeader.product_id,
            hours_meter: this.checklistHeader.hours_meter,
            user_id: this.selectedUserTarget,
            header_request_id: this.checklistHeader.id,
            origin_id: this.checklistHeader?.origin_id,
            destination_id: this.checklistHeader?.destination_id,
            chassis: this.checklistHeader?.chassis,
            date: new Date().toISOString(),
            target: this.checklistHeader.UserModel.email,
            client_name: this.checklistHeader.client_name,
            client_email: this.checklistHeader.client_email,
            client_phone: this.checklistHeader.client_phone,
          }),
          this.loader
        )
        .subscribe({
          next: () => {
            if (this.checklistHeader)
              this.checklistHeader.header_request_id = this.checklistHeader?.id
          }
        })
  }

  showModal (index: number): void {
    this.isVisible[index] = true
  }

  handleCancel (index: number): void {
    this.isVisible[index] = false
  }

  openReplacePicker (imageId: number): void {
    document.getElementById('replace-image-' + imageId)?.click()
  }

  replacedImages (item: Checklist): ChecklistImageModel[] {
    return (item.ChecklistImageModels ?? []).filter((image) => !!image.replaced_at)
  }

  isReplaced (item: Checklist): boolean {
    return this.replacedImages(item).length > 0
  }

  replacedLabel (item: Checklist): string {
    const replaced = this.replacedImages(item)
    if (replaced.length === 0) {
      return ''
    }
    if (replaced.length === 1) {
      return this.imageReplacedLabel(replaced[0])
    }
    return `${replaced.length} fotos alteradas`
  }

  imageReplacedLabel (image: ChecklistImageModel): string {
    if (!image.replaced_at) {
      return ''
    }
    const name = image.ReplacedByUser?.name || 'Administrador'
    const date = new Date(image.replaced_at).toLocaleString('pt-BR')
    return `Substituído por ${name} em ${date}`
  }

  onReplaceSelected (event: Event, item: Checklist, image: ChecklistImageModel): void {
    const input = event.target as HTMLInputElement
    const file = input.files?.[0]
    input.value = ''
    if (!file || !image?.id) {
      return
    }

    this.modalService.confirm({
      nzTitle: 'Substituir foto?',
      nzContent:
        'A foto original do campo permanece no histórico. A tela passará a exibir a nova imagem.',
      nzOkText: 'Substituir',
      nzCancelText: 'Cancelar',
      nzOnOk: () =>
        new Promise<void>((resolve, reject) => {
          this.loaderService
            .executeWithLoader(this.checklistImageService.replaceFile(image.id, file))
            .subscribe({
              next: (updated) => {
                const index = item.ChecklistImageModels.findIndex(
                  (current) => current.id === image.id,
                )
                if (index >= 0) {
                  item.ChecklistImageModels[index] = {
                    ...item.ChecklistImageModels[index],
                    ...updated,
                  }
                }
                this.edited.emit(true)
                this.notificationService.success(
                  'Tudo certo!',
                  'Foto substituída com sucesso.',
                )
                resolve()
              },
              error: (error: HttpErrorResponse) => {
                this.notificationService.error(
                  `${error.status || 'Erro'}`,
                  error.error?.message ?? 'Não foi possível substituir a foto.',
                )
                reject()
              },
            })
        }),
    })
  }
}
